import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=2869dc3c&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=ts"
export * from "./CloseButton.vue?vue&type=script&lang=ts"
import style0 from "./CloseButton.vue?vue&type=style&index=0&id=2869dc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869dc3c",
  null
  
)

export default component.exports